import Nullstack from 'nullstack';
export default function IconAccessPoint({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-access-point",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "12",
    x2: "12",
    y2: "12.01"
  }), "   ", Nullstack.element("path", {
    d: "M14.828 9.172a4 4 0 0 1 0 5.656"
  }), "   ", Nullstack.element("path", {
    d: "M17.657 6.343a8 8 0 0 1 0 11.314"
  }), "   ", Nullstack.element("path", {
    d: "M9.168 14.828a4 4 0 0 1 0 -5.656"
  }), "   ", Nullstack.element("path", {
    d: "M6.337 17.657a8 8 0 0 1 0 -11.314"
  }), " ");
}